enum KeyMapType {
  InstanceCanvasMove
}

export default KeyMapType;
